<div class="report-page">

  <!-- Page header -->
  <header class="report-page__header">
    <div class="report-page__title-group">
      <span class="report-page__icon">
        <i class="pi pi-gauge"></i>
      </span>
      <div>
        <h1 class="report-page__title">AI Limits</h1>
        <p class="report-page__subtitle">
          AI feature rate-limit and quota usage tracked from the NotesApp logging tables.
        </p>
      </div>
    </div>
    <p-button
      label="Close"
      icon="pi pi-times"
      severity="secondary"
      (onClick)="close()">
    </p-button>
  </header>

  <!-- Report card -->
  <p-card styleClass="report-page__card">
    <iframe
      [src]="grafanaUrl"
      class="report-page__iframe"
      frameborder="0"
      allowfullscreen>
    </iframe>
  </p-card>

</div>
